export function createPlural(value?: number, strings?: string[]) {
  return typeof value !== 'undefined' && strings && strings.length > 0
    ? ` ${+value === 1 ? strings[0] : strings[1]}`
    : '';
}
